module.exports = __webpack_public_path__ + "static/media/engineer-papers.23b25f2d.jpg";